/* Zahra redesign – arrow controls for horizontal tracks */
(function () {
  function init(root) {
    (root || document).querySelectorAll('.zh-section').forEach(function (sec) {
      var track = sec.querySelector('[data-zh-track]');
      var arrows = sec.querySelector('[data-zh-arrows]');
      if (!track || !arrows || arrows.dataset.ready) return;
      arrows.dataset.ready = '1';
      var rtl = getComputedStyle(track).direction === 'rtl';
      var btns = arrows.querySelectorAll('.zh-arrow');
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        var pos = Math.abs(track.scrollLeft);
        btns[0].disabled = pos <= 2;
        btns[1].disabled = pos >= max;
        arrows.style.visibility = max <= 2 ? 'hidden' : 'visible';
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = parseInt(b.dataset.dir, 10) * (rtl ? -1 : 1);
          track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Zahra redesign – color swatches show the real variant photo and swap the card image */
(function () {
  function swap(sw) {
    var card = sw.closest('.zh-card');
    if (!card || !sw.dataset.img) return;
    var img = card.querySelector('.zh-card__img:not(.zh-card__img--alt)');
    if (!img) return;
    img.srcset = sw.dataset.srcset || '';
    img.src = sw.dataset.img;
    card.querySelectorAll('.zh-sw').forEach(function (s) { s.classList.toggle('is-active', s === sw); });
  }
  document.addEventListener('mouseover', function (e) { var sw = e.target.closest && e.target.closest('.zh-sw--img'); if (sw) swap(sw); });
  document.addEventListener('click', function (e) { var sw = e.target.closest && e.target.closest('.zh-sw--img'); if (sw) { e.preventDefault(); swap(sw); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { var sw = e.target.closest && e.target.closest('.zh-sw--img'); if (sw) { e.preventDefault(); swap(sw); } } });
})();

/* Zahra – cart offer bar: lives in its own slot ABOVE the drawer's item list
   (never inside it, so the theme's line-based +/- buttons keep working) */
(function () {
  if (window.__zhOfferSync) return; window.__zhOfferSync = true;
  var timer = null;
  function slot() {
    var list = document.querySelector('#t4s-mini_cart [data-cart-items]');
    if (!list || !list.parentNode) return null;
    var s = list.parentNode.querySelector(':scope > .zh-offer-slot');
    if (!s) { s = document.createElement('div'); s.className = 'zh-offer-slot'; list.parentNode.insertBefore(s, list); }
    return s;
  }
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var s = slot(); if (!s) return;
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + '?section_id=zh-cart-offer', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrap = doc.querySelector('.shopify-section') || doc.body;
        var target = slot(); if (target) target.innerHTML = wrap.innerHTML;
      }).catch(function () {});
    }, 300);
  }
  var isCart = function (u) { return /\/cart\/(add|change|update|clear)/.test(String(u || '')); };
  var f = window.fetch;
  if (f) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var p = f.apply(this, arguments);
      if (isCart(url)) p.then(refresh, function () {});
      return p;
    };
  }
  var open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) { if (isCart(url)) this.addEventListener('loadend', refresh); return open.apply(this, arguments); };
  function watch() {
    var drawer = document.getElementById('t4s-mini_cart');
    if (!drawer) return;
    new MutationObserver(function () {
      var list = drawer.querySelector('[data-cart-items]');
      if (list && !list.parentNode.querySelector(':scope > .zh-offer-slot')) refresh();
    }).observe(drawer, { childList: true, subtree: true });
    refresh();
  }
  if (document.readyState !== 'loading') watch(); else document.addEventListener('DOMContentLoaded', watch);
})();
